import axiosInstance from './axiosInstance';
import API from '../constants/api.constant';
import {responseErrorHandling} from '../helper/common.helper';

export const getAllBusinessesAdmin = async (page = 1, limit = 10, search = '') => {
  try {
    const response = await axiosInstance.get(API.GET_ALL_BUSINESSES_ADMIN, {
      params: { page, limit, search },
    });
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const getBusinessDetails = async (businessId: string, employeeSearch = '', customerSearch = '', coOwnerSearch = '') => {
  try {
    const response = await axiosInstance.get(`${API.GET_BUSINESS_DETAILS_ADMIN}${businessId}`, {
      params: { employeeSearch, customerSearch, coOwnerSearch },
    });
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const getCustomerDetailsAdmin = async (customerId: string) => {
  try {
    const response = await axiosInstance.get(`${API.GET_CUSTOMER_DETAILS_ADMIN}${customerId}`);
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const getAllBankersAdmin = async (page = 1, limit = 10, search = '') => {
  try {
    const response = await axiosInstance.get(API.GET_ALL_BANKERS_ADMIN, {
      params: { page, limit, search },
    });
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const getAllBankerDetailsById = async (bankerId: string) => {
  try {
    const response = await axiosInstance.get(API.GET_BANKER_DETAILS_ADMIN + bankerId);
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const getActivityLogsAdmin = async (
  page = 1,
  limit = 25,
  search = '',
  action = '',
) => {
  try {
    const response = await axiosInstance.get(API.GET_ACTIVITY_LOGS_ADMIN, {
      params: { page, limit, search, action },
    });
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};
